import React from "react";
import { Link } from "react-router-dom";
import '../nav.css'; // Scoped custom CSS for navbar only

function Nav() {
  return (
    <nav className="custom-navbar">
      <div className="custom-container">
        <Link className="custom-brand" to="/">Pentagon Properties</Link>

        <input type="checkbox" id="menu-toggle" className="custom-menu-toggle" />
        <label htmlFor="menu-toggle" className="custom-toggler">
          <span className="toggler-text">MENU</span>
          <i className="fas fa-bars" aria-hidden="true"></i>
        </label>

        <ul className="custom-menu">
          <li><a href="#Rentals">Properties</a></li>
          <li><a href="#team">Team</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </div>
    </nav>
  );
}

export default Nav;
